export interface KeyValue {
	value: string | number;
	text: string;
}
